<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">
            <div class="d-flex align-items-center">
    			<h1 class="flex-grow-1" data-test="pageTitle">Manage Frontpage Promos</h1>
                <span 
                    @click="displayAddForm(true)"
                    class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none"
                    v-tooltip.bottom="'Add Promo'"
                    data-test="addPromoButton">
                    <i class="far fa-plus-circle text-xl"></i>
                </span>
            </div>
        </div>
		
        <div class="col-12">
			<div class="card">
				<table class="table">
					<thead>
						<th>Title</th>
						<th>Active</th>
						<th>Actions</th>
					</thead>
					<tr v-for="promo in promos">
						<td>{{ promo.title }}</td>
						<td>{{ promo.active }}</td>
						<td><span class="btn btn-sm btn-primary" @click="setEditing(promo.id)" data-test="editFrontPromoButton">Edit</span></td>
					</tr>
				</table>
			</div>

            <div class="card" v-if="editing">
                <div class="card-header">Edit Promo: {{ editing.title }}</div>
                <div class="card-body">
                    <div class="form-group">
                        <label class="mb-0">Title</label>
                        <input class="form-control" v-model="editing.title" data-test="editFrontPromoTitle">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Message</label>
                        <input class="form-control" v-model="editing.message" data-test="editFrontPromoMessage">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Image URL</label>
                        <input class="form-control" v-model="editing.image_url" required data-test="editFrontPromoImageUrl">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Image Style (CSS)</label>
                        <input class="form-control" v-model="editing.image_style" required data-test="editFrontPromoImageStyle">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Active</label>
                        <select class="form-control" v-model="editing.active" data-test="editFrontPromoActive">
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <span class="btn btn-ghost-warning" @click="deletePromo(editing.id)">Delete</span>
                        <span class="btn btn-ghost-secondary" @click="displayAddForm(false)">Cancel</span>
                        <span class="btn btn-primary" @click="updatePromo(editing.id)" data-test="updateFrontPromoButton">Save Promo</span>
                    </div>                                                  
                </div>
            </div>

            <div class="card" v-if="showAddForm">
                <div class="card-header">New Promo</div>
                <div class="card-body">
                    <div class="form-group">
                        <label class="mb-0">Title</label>
                        <input class="form-control" v-model="newPromo.title" data-test="newFrontPromoTitle">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Message</label>
                        <input class="form-control" v-model="newPromo.message" data-test="newFrontPromoMessage">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Image URL</label>
                        <input class="form-control" v-model="newPromo.image_url" required data-test="newFrontPromoImageUrl">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Image Style (CSS)</label>
                        <input class="form-control" v-model="newPromo.image_style" required data-test="newFrontPromoImageStyle">
                    </div>
                    <div class="form-group">
                        <label class="mb-0">Active</label>
                        <select class="form-control" v-model="newPromo.active" data-test="newFrontPromoActive">
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <span class="btn btn-ghost-secondary" @click="displayAddForm(false)">Cancel</span>
                        <span class="btn btn-primary" @click="submitPromo()" data-test="saveFrontPromoButton">Save Promo</span>
                    </div>                                                  
                </div>
            </div>
		</div>
	</div>
</div>
</template>

<script>
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
        mixins: [BreadcrumbsManager],

        data() {
            return {
                promos: [],

                newPromo: {
                	title: null,
                    message: null,
                    image_url: null,
                    image_style: null,
                    active: null,
                },

                editing: null,
                showAddForm: false,
            }
        },

        created() {
        	this.fetchPromos();
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Settings', to: { name: '' } },
                { text: 'Front Promos', to: { name: 'admin.front_promos' } },
            ]);   
        },

        methods: {    
            deletePromo(id) {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'You will not be able to recover this promo!',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Delete promo',
                      cancelButtonText: 'Keep promo',
                      animation: false,
                    }).then((result) => {
                        if (result.value) {
                            axios.delete(`/api/front-promos/${id}`, id).then(() => {
                                this.promos.splice(this.promoIndex(id), 1);
                                this.editing = null;
                            })
                        }
                    }
                );
            },

            displayAddForm(value) {
                this.showAddForm = value;
            },

        	fetchPromos() {
                axios.get(`/api/front-promos`).then(({data}) => {
                    this.promos = data;
                });
        	},


            promoIndex(id) {
                return this.promos.findIndex((promo) => {
                    return promo.id === id;
                });
            },

            setEditing(id) {
                const promo = this.promos.find(x => x.id === id);
                this.editing = {
                    id: promo.id,
                    title: promo.title,
                    message: promo.message,
                    image_url: promo.image_url,
                    image_style: promo.image_style,
                    active: promo.active,
                };
            },

            submitPromo() {
                axios.post('/api/front-promos', this.newPromo).then(({data}) => {
                    this.promos.push(data);
                    this.newPromo = {
                        title: null,
                        message: null,
                        image_url: null,
                        image_style: null,
                        active: null,
                    };                    
                    this.displayAddForm(false);
                });
            },

            updatePromo(id) {
                axios.put(`/api/front-promos/${id}`, this.editing).then(({data}) => {
                    this.promos.find(x => x.id === id).title = data.title;
                    this.promos.find(x => x.id === id).active = data.active;
                    this.editing = null;
                });
            },

        },
    }
</script>